const pricingDefaultValues: Record<string, string> = {
  'pricing.launch_offer_limited_period': 'Launch offer \u2014 limited period',
  'pricing.no_credit_card_required': 'No credit card required.',
  'pricing.most_popular': 'Most popular',
  'pricing.enterprise_label': 'Enterprise',
  'pricing.feature_labels.includes': 'Includes',
  'pricing.feature_labels.built_for_institutions': 'Built for institutions',
  'pricing.trust_strip.aria_label': 'Why you can trust Sarvalok',
  'pricing.trust_strip.gdpr_title': 'GDPR compliant',
  'pricing.trust_strip.gdpr_subtitle': 'Data stays protected, always.',
  'pricing.trust_strip.cancel_title': 'Cancel anytime',
  'pricing.trust_strip.cancel_subtitle': 'No contracts, no cliffs.',
  'pricing.trust_strip.payment_methods_title': 'All major payment methods',
  'pricing.trust_strip.payment_methods_subtitle': 'Cards, UPI, netbanking.',
  'pricing.trust_strip.token_policy_title': 'Transparent token policy',
  'pricing.trust_strip.token_policy_subtitle': 'Credits refresh by plan.',
  'pricing.one_time': '/one-time',
  'pricing.custom_pricing': 'Custom pricing',
  'pricing.talk_to_our_team': 'Talk to our team',
  'pricing.upgrade_to_explorer': 'Start Explorer',
  'pricing.prices_exclude_gst': 'Prices exclude 18% GST (added at checkout).',
  'pricing.base_price_gst_note': 'Base price shown. 18% GST is added at checkout.',
  'pricing.plan_subtitles.free': 'For the newly curious.',
  'pricing.plan_subtitles.explorer': 'For regular study.',
  'pricing.plan_subtitles.scholar': 'For serious research.',
  'pricing.plan_subtitles.sage': 'For daily practice.',
  'pricing.plan_subtitles.enlightened': 'For institutions and teams.',
  'pricing.plan_descriptions.enlightened': 'For universities, institutes, and publishers.',
  'pricing.token_labels.output_tokens_one_time': '{{count}} starter credits (one-time)',
  'pricing.token_labels.output_tokens_per_month': '{{count}} monthly credits',
  'pricing.token_labels.total_output_tokens_per_month': '{{count}} monthly credits',
  'pricing.token_labels.total_output_tokens_per_year': '{{count}} yearly credits ({{perMonth}}/mo)',
  'pricing.token_labels.add_output_tokens_one_time': 'Add {{count}} credits (one-time)',
  'pricing.token_labels.add_output_tokens_existing_plan': 'Add {{count}} credits to your existing plan',
  'pricing.mission_badge.checkout_label': 'Heritage Preservation',
  'pricing.mission_badge.checkout_body': 'Your subscription supports the digitization of ancient Vedic manuscripts.',
  'pricing.mission_badge.label': 'Mission Driven',
  'pricing.mission_badge.title': 'Pricing that protects the past.',
  'pricing.mission_badge.body': 'Every plan funds manuscript research. Proceeds support the digitization and study of rare ancient texts.',
  'pricing.mission_badge.compact_body': 'Every plan protects ancient manuscripts',
  'pricing.payment_methods.more': '+ more',
  'pricing.payment_methods.caption': 'All major cards accepted. Additional local payment methods may appear at checkout.',
  'pricing.token_policy.point3_inr': 'Top-ups: \u20B9294 for 1,800 output tokens (paid plans only, non-refundable).',
};

export function getPricingDefaultValue(key: string): string | undefined {
  return pricingDefaultValues[key];
}
